import { findIndex } from 'lodash';
import * as areaActionTypes from './therapeuticAreaActionTypes';
import * as areaParameterActionTypes from '../areaParameters/areaParametersActionTypes';

const areaInitialState = {
  id: '',
  name: '',
  areaParameters: [],
  category: {
    id: '',
    name: '',
  },
};

const therapeuticAreaReducer = (state = areaInitialState, action) => {
  switch (action.type) {
    case areaActionTypes.SET_AREA: {
      const { area } = action;
      return area;
    }

    case areaActionTypes.UPDATE_AREA: {
      const { area } = action;
      return {
        ...state,
        name: area.name,
      };
    }

    case areaParameterActionTypes.ADD_AREA_PARAMETER: {
      const { areaParameter } = action;
      return {
        ...state,
        areaParameters: [...state.areaParameters, ...[areaParameter]],
      };
    }

    case areaParameterActionTypes.UPDATE_AREA_PARAMETER: {
      const { areaParameter } = action;
      return {
        ...state,
        areaParameters: state.areaParameters.map((item) => {
          if (item.id === areaParameter.id) {
            return { ...item, importance: areaParameter.importance };
          }
          return item;
        }),
      };
    }

    case areaParameterActionTypes.DELETE_AREA_PARAMETER: {
      const areaParameterIndex = findIndex(
        state.areaParameters,
        (item) => item.id === action.areaParameter.id
      );
      return {
        ...state,
        areaParameters: [
          ...state.areaParameters.splice(0, areaParameterIndex),
          ...state.areaParameters.splice(areaParameterIndex + 1),
        ],
      };
    }

    default:
      return state;
  }
};

export default therapeuticAreaReducer;



// WEBPACK FOOTER //
// ./src/therapeuticArea/therapeuticAreaReducer.js